import { computed, toRefs } from '@vue/composition-api'
import { cloneDeep } from 'lodash-es'

// debug: use table tannis market id 237

export default function useMarket10Handicap(props) {
  const { markets } = toRefs(props)

  const marketTitles = ['Home', 'Away']

  const getCustomDesc = (description = '') => {
    return description.match(/\((.*)\)/)[1]
  }

  const sortedMarkets = computed(() => {
    if (!markets.value) return []
    const tempMarkets = cloneDeep(markets.value)
      .filter((x) => x.outcomes && x.outcomes.order)
      .map((x) => {
        const { map, order } = x.outcomes
        order.sort((a) => {
          if (/home/i.test(map[a].description)) return -1
          else return 1
        })
        return x
      })
    tempMarkets.sort((a, b) => {
      const descNumA = parseFloat(getCustomDesc(a.outcomes.map[a.outcomes.order[0]].description))
      const descNumB = parseFloat(getCustomDesc(b.outcomes.map[b.outcomes.order[0]].description))

      // 小于 0 时，绝对值小的优先
      if (descNumA < 0 && descNumB < 0) {
        if (descNumA > descNumB) return -1
        else if (descNumA < descNumB) return 1
        return 0
      }
      // 大于等于 0 时，从小到大
      if (descNumA > descNumB) return 1
      else if (descNumA < descNumB) return -1
      return 0
    })
    return tempMarkets
  })

  return {
    marketTitles,
    sortedMarkets,
    getCustomDesc
  }
}
